"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("./common");
const any_1 = require("./any");
function getBooleanSchemaModifierProviders(getJoi) {
    const result = Object.assign(Object.assign({}, any_1.getAnySchemaModifierProviders(getJoi)), { falsy: (value, ...values) => ({ schema }) => schema.falsy(value, ...values), sensitive: (enabled = true) => ({ schema }) => schema.sensitive(enabled), truthy: (value, ...values) => ({ schema }) => schema.truthy(value, ...values) });
    return result;
}
exports.getBooleanSchemaModifierProviders = getBooleanSchemaModifierProviders;
exports.createBooleanPropertyDecorator = (joifulOptions) => (common_1.createPropertyDecorator()(({ joi }) => joi.boolean(), getBooleanSchemaModifierProviders, joifulOptions));
//# sourceMappingURL=boolean.js.map